export default __webpack_public_path__ + "static/media/emmet.1cffbd88.svg";